function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import { isPostalRequired, isRegionRequired } from 'js-utils/intl';
import BaseAddressFields from '../baseAddressFields/BaseAddressFields';
import { ADDRESS_VALUES_PROP, DISABLED_FIELDS_PROP } from '../baseAddressFields/constants';
import { REGIONS_BY_COUNTRY_PROP, COUNTRIES_PROP } from './constants';
import { getAdditionalProps } from '../utils/propTypes';
import { getRegionLabel, getPostalLabel, formatCountriesForDropdown, formatRegionsForDropdown } from './lib';

var getCountryFromLocale = function getCountryFromLocale(locale) {
  return locale.split('_')[1];
};

var AddressFields =
/*#__PURE__*/
function (_Component) {
  _inherits(AddressFields, _Component);

  function AddressFields(props, context) {
    var _this;

    _classCallCheck(this, AddressFields);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddressFields).call(this, props, context));
    var country = props.values.country || props.defaultValues.country;
    var locale = props.locale || context.locale;

    if (!country && locale) {
      country = getCountryFromLocale(locale);
    }

    _this.state = {
      country: country
    };
    return _this;
  }

  _createClass(AddressFields, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          countries = _this$props.countries,
          regionsByCountry = _this$props.regionsByCountry,
          onCountriesUnknown = _this$props.onCountriesUnknown,
          onRegionsUnknown = _this$props.onRegionsUnknown;

      if (!countries.isLoading && !countries.content && onCountriesUnknown) {
        onCountriesUnknown();
      }

      if (!regionsByCountry.isLoading && !regionsByCountry.content && onRegionsUnknown) {
        onRegionsUnknown();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref) {
      var country = _ref.values.country;

      // allows setting an existing `input` element's value via props from a parent
      if (country !== undefined) {
        this.setState({
          country: country
        });
      }
    }
  }, {
    key: "_handleCountryChange",
    value: function _handleCountryChange(country) {
      this.setState({
        country: country
      });

      if (this.props.onCountryChange) {
        this.props.onCountryChange(country);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          regionsByCountry = _this$props2.regionsByCountry,
          countries = _this$props2.countries,
          defaultValues = _this$props2.defaultValues,
          disabledFields = _this$props2.disabledFields,
          label = _this$props2.label,
          hideLabels = _this$props2.hideLabels,
          error = _this$props2.error,
          idPrefix = _this$props2.idPrefix,
          namePrefix = _this$props2.namePrefix,
          onChange = _this$props2.onChange,
          onBlur = _this$props2.onBlur,
          required = _this$props2.required,
          v2 = _this$props2.v2,
          shouldDisplayError = _this$props2.shouldDisplayError;
      var country = this.state.country;
      var regions = regionsByCountry.content && regionsByCountry.content[country];
      var regionValues = regions && formatRegionsForDropdown(regions);
      var postalRequired = isPostalRequired(countries.content, country);

      var values = _objectSpread({}, this.props.value, {
        country: country
      });

      var extraAttrs = getAdditionalProps(this);
      return React.createElement(BaseAddressFields, _extends({}, extraAttrs, {
        defaultValues: defaultValues,
        values: values,
        countryValues: formatCountriesForDropdown(countries.content),
        regionLabel: getRegionLabel(country),
        regionRequired: isRegionRequired(country),
        regionValues: regionValues,
        postalLabel: getPostalLabel(country),
        postalRequired: postalRequired,
        postalShown: postalRequired,
        onCountryChange: this._handleCountryChange.bind(this),
        error: error,
        idPrefix: idPrefix,
        namePrefix: namePrefix,
        onChange: onChange,
        onBlur: onBlur,
        required: required,
        disabledFields: disabledFields,
        label: label,
        hideLabels: hideLabels,
        v2: v2,
        shouldDisplayError: shouldDisplayError
      }));
    }
  }]);

  return AddressFields;
}(Component);

_defineProperty(AddressFields, "propTypes", _objectSpread({}, omit(BaseAddressFields.propTypes, 'countryValues'), {
  /**
  * An object with address fields to be set as default
  * ex. {address1: '123 Fifth St.', address2: 'Unit 1', city: 'San Francisco', region: 'CA', postal: '94103', country: 'United States'}
  **/
  defaultValues: ADDRESS_VALUES_PROP,

  /**
   * An object with address fields to be disabled
   * ex. {country: true}
   */
  disabledFields: DISABLED_FIELDS_PROP,

  /**
  * An object with address fields that overrides defaultValues with fixed values
  * ex. {address1: '123 Fifth St.', address2: 'Unit 1', city: 'San Francisco', region: 'CA', postal: '94103', country: 'United States'}
  **/
  values: ADDRESS_VALUES_PROP,

  /**
  * a `regionsByCountry` object with the following format:
  * {isLoading: false, content: {US: [{code: 'CA', label: 'California'}, ...], ...}
  * Used to populate the country specific regions.
  **/
  regionsByCountry: REGIONS_BY_COUNTRY_PROP,

  /**
  * Callback to handle asnychronous loading of the regions if no regionsByCountry
  * prop is passed in.
  **/
  onRegionsUnknown: PropTypes.func,

  /**
  * The component desires to receive a `countries` object with the following format:
  * {isLoading: false, content: [{code: 'AF', label: 'Afghanistan', zip_required: false}, ...]}
  **/
  countries: COUNTRIES_PROP,

  /**
  * Callback to handle asynchronous loading of available Countries if no prop is passed in.
  **/
  onCountriesUnknown: PropTypes.func,

  /**
   * A callback triggered when the value of country changes, passing in the value of country as a parameter
   * ex. (value) => { console.log(value) // 'US' }
   */
  onCountryChange: PropTypes.func,

  /**
  * A string specifying the default country for AddressFields
  * In the form of country code: 'US', 'CA', etc.
  **/
  locale: PropTypes.string,

  /**
   * Text to render label-like above the fields
   */
  label: PropTypes.node,

  /**
   * Hides label above the fields
   */
  hideLabels: PropTypes.bool,

  /**
   * Determines whether it should use or not a FormField wrapper.
   */
  v2: PropTypes.bool,

  /**
   * Function to determine whether we should
   * display an error given the input state. Has a sensible default.
   */
  shouldDisplayError: PropTypes.func
}));

_defineProperty(AddressFields, "defaultProps", {
  regionsByCountry: {},
  countries: {},
  defaultValues: {},
  disabledFields: {},
  values: {},
  hideLabels: false,
  v2: false
});

_defineProperty(AddressFields, "contextTypes", {
  locale: PropTypes.string
});

export { AddressFields as default };